export { default } from './CapcaleraAutor';
